/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TransformRotate(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TransformRotate',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 13 * scale,
      viewBox: '0 0 13 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M10.7 5H12V1l-1.6 1.6C9.4 1.6 8 1 6.5 1 3.5 1 1 3.5 1 6.5S3.5 12 6.5 12c2.9 0 5.2-2.2 5.5-5h-1c-.3 2.2-2.1 4-4.4 4C4 11 2 9 2 6.5S4 2 6.5 2c1.2 0 2.4.5 3.2 1.3L8 5z"}))
}
